import { ArgsType, Field, Int } from '@nestjs/graphql'
import { BaseGetArgs } from '../../base/baseGet.args'

@ArgsType()
export class ArcTeamMemberGetArgs extends BaseGetArgs<ArcTeamMemberGetArgs> {
  @Field(t => Int)
  teamId!: number

  @Field(t => Int)
  status: number = -1

  @Field(t => Int)
  type: number = -1

  @Field()
  needle: string = ''
}
